/**
 * ask-concierge-helpers.js — pure-logic helpers extracted from
 * AskConciergePill.jsx so the unit tests can run on the existing
 * Jest config (which doesn't transform JSX).
 *
 * Doctrine pinned here so the tests can guard it cleanly:
 *   - Founder WhatsApp is the safe default · ZERO AI behind the
 *     Concierge® mark
 *   - REACT_APP_P4_MIRA_LIVE=true flips routing to /mira
 *   - Pre-filled message always names the venue (honest absence
 *     when a field is missing · never "null" or "undefined" leaks)
 */

// Founder's verified WhatsApp number (Gupshup source). Same number
// as the existing /table "Talk to a Concierge®" pill so the
// receive surface is unified for the team.
export const FOUNDER_WHATSAPP = "918792622424";


export function buildAskMessage(venueName, venueCity, conciergeRef) {
    const lines = [];
    lines.push("Hi Concierge\u00ae \u00b7 I'm holding the dossier and have a question.");
    if (venueName) {
        const tail = venueCity ? `${venueName} \u00b7 ${venueCity}` : venueName;
        lines.push("");
        lines.push(`About: ${tail}`);
    }
    if (conciergeRef) {
        lines.push(`Dossier ref: ${conciergeRef}`);
    }
    lines.push("");
    lines.push("Question: ");
    return lines.join("\n");
}


export function isMiraLive() {
    try {
        return String(process.env.REACT_APP_P4_MIRA_LIVE || "")
            .toLowerCase().trim() === "true";
    } catch {
        return false;
    }
}


/**
 * Build the target URL the pill should send the client to.
 * Returns { href, label, miraLive }.
 *
 *   - Mira-OFF (default · safe): wa.me/<founder> with the venue name
 *     pre-filled in the message body
 *   - Mira-ON (founder-flipped after live test): /mira?venue=...
 *     with the venue context as query params
 */
export function buildAskConciergeTarget({
    venueName, venueCity, draftId, miraHref,
}) {
    if (isMiraLive()) {
        const params = new URLSearchParams({
            venue: venueName,
            ...(venueCity ? { city: venueCity } : {}),
            ...(draftId ? { ref: draftId } : {}),
            intent: "ask_venue",
        });
        return {
            href: miraHref || `/mira?${params.toString()}`,
            label: "Ask Mira",
            miraLive: true,
        };
    }
    const message = buildAskMessage(venueName, venueCity, draftId);
    return {
        href: `https://wa.me/${FOUNDER_WHATSAPP}?text=${encodeURIComponent(message)}`,
        label: "Ask a Concierge\u00ae",
        miraLive: false,
    };
}
